import { useState, useEffect, useMemo, useRef } from "react";
import { getBackgrounds, deleteBackground } from "../../../api/backgroundApi";
import { BsThreeDotsVertical } from "react-icons/bs";
import "./BackgroundTable.css";
import useShopItems from "../../../hooks/useShopItems";

export default function BackgroundTable({ searchText, selectedFilter }) {
  const [backgrounds, setBackgrounds] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  const [loading, setLoading] = useState(true);

  const isFirstLoad = useRef(true);

  const { fetchBackgroundItems, backgroundItems, loadingBackgroundItems } =
    useShopItems();

  useEffect(() => {
    const fetcData = async () => {
      let filter = selectedFilter.toLowerCase();
      if (filter === "all") {
        filter = null;
      }
      await fetchBackgroundItems(filter);
    };
    fetcData();
  }, [selectedFilter]);

  // useEffect(() => {
  //   fetchBackgrounds();
  // }, []);

  const fetchBackgrounds = async () => {
    try {
      setLoading(true);
      const data = await getBackgrounds();

      const tableData = data.map((b, index) => ({
        srn: index + 1,
        _id: b._id,
        itemName: b.name,
        itemCategory: "Background",
        itemSubCategory: b.price === 0 ? "Basic" : "Premium",
        coin: b.price,
        itemUsage: b.adCount,
        createdAt: b.createdAt,
        status: "active",
      }));

      setBackgrounds(tableData);
      isFirstLoad.current = false;
    } catch (err) {
      console.error("Failed to load backgrounds", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (_id) => {
    if (!window.confirm("Are you sure you want to delete this background?"))
      return;

    try {
      setLoading(true);
      await deleteBackground(_id);
      setBackgrounds((prev) => prev.filter((b) => b._id !== _id));
      setOpenMenu(null);
    } catch (err) {
      console.error("Delete failed", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = useMemo(() => {
    let result = backgrounds;

    if (selectedFilter !== "All") {
      result = result.filter((b) => b.itemSubCategory === selectedFilter);
    }

    if (searchText.trim()) {
      const query = searchText.toLowerCase();
      result = result.filter(
        (b) =>
          b.itemName.toLowerCase().includes(query) ||
          b.itemCategory.toLowerCase().includes(query) ||
          b.itemSubCategory.toLowerCase().includes(query),
      );
    }

    return result;
  }, [backgrounds, selectedFilter, searchText]);

  return (
    <div className="bg-table-wrapper">
      <div className="bg-table-container">
        {/* Header */}
        <div className="bg-table-header">
          <div>SRN</div>
          <div>Image</div>
          <div>Name</div>
          <div>Category</div>
          {/* <div>Sub Category</div> */}
          <div>Coins</div>
          <div>Cash</div>
          <div>Type</div>
          <div>Added At</div>
          {/* <div>Status</div> */}
          {/* <div className="align-right">Action</div> */}
        </div>

        {/* Body */}
        <div className="bg-table-body">
          {loadingBackgroundItems ? (
            <div className="bg-table-message">Loading...</div>
          ) : !loadingBackgroundItems && backgroundItems.length === 0 ? (
            <div className="bg-table-message">No items found.</div>
          ) : (
            backgroundItems.map((item, index) => (
              <div key={item._id} className="bg-table-row">
                <div>{index + 1}</div>
                <div>
                  <img
                    style={{
                      objectFit: "contain",
                      height: "60px",
                      width: "40px",
                    }}
                    src={item.image}
                  />
                </div>
                <div>{item.name}</div>
                <div>{item.type}</div>
                {/* <div>{item.itemSubCategory}</div> */}
                <div>{item.priceCoins}</div>
                <div>{item.priceCash}</div>
                <div>
                  {item.priceCoins <= 0 || item.priceCash <= 0
                    ? "Free"
                    : "Paid"}
                </div>
                <div className="date">
                  {item.createdAt
                    ? new Date(item.createdAt).toLocaleString()
                    : "-"}
                </div>
                {/* <div>
                  <span className="status active">Active</span>
                </div> */}

                {/* <div className="action-cell">
                  <button
                    onClick={() =>
                      setOpenMenu(openMenu === item._id ? null : item._id)
                    }
                    className="action-btn"
                  >
                    <BsThreeDotsVertical />
                  </button>

                  {openMenu === item._id && (
                    <div className="action-menu">
                      <button
                        onClick={() => handleDelete(item._id)}
                        className="delete-btn"
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div> */}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
